import InnerComponent from '@Components/Production/ManualProductionEntry/ManualProductionEntryForm';
import orgContainer from '@Components/AppContainer';

const ManualProductionEntryForm = () => ((orgContainer(InnerComponent)));
export default ManualProductionEntryForm;
